<div class="d-flex d-lg-none text-info align-items-center bg-light-gray container-fluid" *ngIf="mustShow$ | async">
  <div class="flex-fill">
    <span translate>Your preferred currency</span>
  </div>
  <app-currency-select btnClass="btn-default btn-sm font-size-14" class="ms-auto me-2 text-white"></app-currency-select>
  <div class="align-self-center" (click)="close()">
    <i class="icon icon-times icon-61"></i>
  </div>
</div>
